import { supabase } from '@/lib/supabase';
import type { AuditAction, AuditResourceType } from '@ellie/shared';

/**
 * Log an admin action to the audit trail.
 *
 * Fire-and-forget — errors are caught and logged to console so they never
 * block the UI action that triggered the log.
 */
export async function logAudit(params: {
  action: AuditAction;
  resourceType: AuditResourceType;
  resourceId?: string;
  metadata?: Record<string, unknown>;
}): Promise<void> {
  try {
    const {
      data: { user },
    } = await supabase.auth.getUser();

    if (!user) {
      console.warn('[audit] No authenticated user — skipping audit log');
      return;
    }

    const { error } = await supabase.from('admin_audit_log').insert({
      admin_id: user.id,
      action: params.action,
      resource_type: params.resourceType,
      resource_id: params.resourceId ?? null,
      metadata: params.metadata ?? {},
    });

    if (error) {
      console.error('[audit] Failed to insert audit log:', error.message);
    }
  } catch (err) {
    console.error('[audit] Unexpected error:', err);
  }
}
